// src/components/CategoryList.tsx

import React, { useEffect, useState } from 'react';
import { fetchCategories, fetchProductsByCategory } from '../utils/api'; // Adjust the import based on your project structure
import { Category } from '../utils/types'; // Ensure this is the correct path to your types

interface CategoryListProps {
    onSelectCategory: (categoryId: number) => void; // Define the prop type
}

const CategoryList: React.FC<CategoryListProps> = ({ onSelectCategory }) => {
    const [categories, setCategories] = useState<Category[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    const [itemCounts, setItemCounts] = useState<{ [key: number]: number }>({});

    useEffect(() => {
        const loadCategories = async () => {
            try {
                const data = await fetchCategories();
                setCategories(data);

                // Fetch item counts for each category
                const counts: { [key: number]: number } = {};
                // console.log(data);
                for (const category of data) {
                    // console.log(category.id, category.name);

                    const products = await fetchProductsByCategory(category.id); // Fetch products by category
                    counts[category.id] = products.length; // Store count
                    // console.log([products.length]);

                }
                setItemCounts(counts);

            } catch (err) {
                setError('Failed to fetch categories');
            } finally {
                setLoading(false);
            }
        };

        loadCategories();
    }, []);

    if (loading) {
        return <div className="text-center">Loading categories...</div>;
    }

    if (error) {
        return <div className="text-red-500 text-center">{error}</div>;
    }

    return (
        <div className=" m-0 px-1 pt-2 relative" style={{ backgroundColor: '#7a75b5' }}>
            <ul className="w-full  space-y-2" style={{ backgroundColor: '#7a75b5' }}>
                {categories.map((category) => (
                    itemCounts[category.id] > 0 && ( // Move the condition here
                        <li
                            key={category.id}
                            className="bg-white border p-1 rounded shadow cursor-pointer w-full text-left text-gray-800"
                            onClick={() => onSelectCategory(category.id)}
                            style={{ fontSize: '0.7rem' }}
                        >
                            {category.name.toUpperCase()}<br />
                            {category.description.toUpperCase() || ''}
                            {/* ({itemCounts[category.id]}) */}
                        </li>
                    )
                ))}
            </ul>
        </div>
    );
};

export default CategoryList;